import React from 'react';
import {
      Link
    } from 'react-router-dom'
const Page404Component = () => {

      return(
<div className="main-cont">
<div className="four-oh-four">    
  404      
</div>
<div className="error">
      <Link to="/" className="homepage-button">Back to Homepage</Link>
</div>
</div>
      )

}

export default Page404Component;